import { httpMethod, useApi } from './useApi';
export const useUpdateUser = () => {
    const { call, data, statusCode, error, ...rest } = useApi({
        authenticated: true,
        version: 1,
        path: 'users',
        httpMethod: httpMethod.PUT,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, statusCode, data: responseData, error, ...rest };
};
